import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  fontWeights,
  fontSizes,
}: Theme) => ({
  buttonSelected: {
    padding: '0.75rem 1rem',
    border: 'none',
    backgroundColor: palette.primary.dark,
    color: palette.common.white,
    '&:hover': {
      backgroundColor: palette.primary.dark,
    },
    '& .MuiButton-endIcon': {
      marginLeft: '0.5rem',
    },
    '& .MuiButton-endIcon > *:nth-of-type(1)': {
      margin: 0,
      fontSize: 'inherit',
    },
  },
  iconWrapper: {
    display: 'flex',
  },
  iconWrapperSelected: {
    display: 'flex',
    filter: 'brightness(0) invert(1)',
  },
  icon: {
    width: '1rem',
    height: '1rem',
  },
  countBadge: {
    display: 'inline-block',
    backgroundColor: palette.common.white,
    color: palette.primary.dark,
    borderRadius: '50%',
    width: '1.3rem',
    height: '1.3rem',
    padding: '0 0.25rem',
    fontSize: fontSizes.sm,
    fontWeight: fontWeights.medium,
    lineHeight: '1.4rem',
  },
}));
